import React from 'react';
import { StyleSheet, Text, TouchableOpacity } from 'react-native';
import Svg from '../Svg';
import Layout from '../../constants/Layout';
import PropTypes from 'prop-types';
import Colors from '../../constants/Colors';

/**
 * Checkbox component that renders a touchable opacity element acting as a checkbox.
 * It displays a checked or unchecked icon based on the `checked` prop and shows a label.
 *
 * @component
 * @param {Object} props - The properties passed to the Checkbox component.
 * @param {Function} props.onPress - The function to call when the checkbox is pressed.
 * @param {boolean} props.checked - Determines if the checkbox is checked or unchecked.
 * @param {string} props.label - The text label displayed next to the checkbox.
 * @returns {ReactElement} The Checkbox component.
 */
export default function Checkbox(props) {
  return (
    <TouchableOpacity onPress={props.onPress} role="checkbox" style={styles.container}>
      <Svg icon={props.checked ? 'square_checked' : 'square_unchecked'} style={styles.checkbox} width={32} />
      <Text style={styles.label}>{props.label}</Text>
    </TouchableOpacity>
  );
}

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onPress: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

const styles = StyleSheet.create({
  container: {
    width: Layout.isCompactScreen ? '100%' : '40%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: 8,
    marginTop: 8,
  },
  label: {
    color: Colors.grayText,
    fontSize: 14,
  },
});
